import React from "react";
import { MdOutlinePhone } from "react-icons/md";
import { CiMail } from "react-icons/ci";
import { FaFacebook, FaLinkedin, FaFacebookMessenger } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { FaXTwitter } from "react-icons/fa6";
import { FaSnapchatGhost } from "react-icons/fa";
function TopBar() {
  return (
    <div className="hidden xl:block">
      <div className="text-gray border-gray/10 flex w-full items-center justify-between border-b px-4 py-4 md:px-12 xl:px-16">
        <div className="flex items-center space-x-4">
          <a
            href="tel:+201070101097"
            className="flex cursor-pointer items-center space-x-2"
          >
            <MdOutlinePhone />
            <span className="text-md">+20 10 70101097</span>
          </a>
          <a
            href="mailto:research@Biostat.com"
            className="flex cursor-pointer items-center space-x-2"
          >
            <CiMail />
            <span className="text-md">research@Biostat.com</span>
          </a>
        </div>
        <div className="flex items-center space-x-4 text-xl">
          <a
            href="https://www.facebook.com/BioStatHouse"
            aria-label="Visit our Facebook page"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.linkedin.com/company/biostathouse/"
            aria-label="Visit our LinkedIn page"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.facebook.com/BioStatHouse"
            aria-label="Chat with us on Messenger"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSnapchatGhost />
          </a>
          <a
            href="https://www.facebook.com/BioStatHouse"
            aria-label="Chat with us on Messenger"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter />
          </a>
          <a
            href="https://www.facebook.com/BioStatHouse"
            aria-label="Chat with us on Messenger"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookMessenger />
          </a>
          <a
            href="https://wa.me/201070101097"
            aria-label="Chat with us on WhatsApp"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <RiWhatsappFill />
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
